import Template from 'templates/Error'

const NotFoundPage = () => <Template type="notfound" statusCode={404} />

export default NotFoundPage
